// https://codesandbox.io/s/github/tanem/react-nprogress/tree/master/examples/next-router?file=/components/Loading.tsx
import classnames from 'classnames'
// import colors from '@/configs/tailwind/tokens/colors'
/**
 * TODO
 * convert to tailwind styles
 */
import { useNProgress } from '@tanem/react-nprogress'

const Loading: React.FC<{ isRouteChanging: boolean }> = ({
  isRouteChanging,
}) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    isAnimating: isRouteChanging,
  })

  return (
    <div
      className={`${classnames('pointer-events-none', {
        'opacity-0': isFinished,
        'opacity-100': !isFinished,
      })}`}
      style={{
        transition: `opacity ${animationDuration}ms linear`,
      }}
    >
      <div
        className="fixed left-0 top-0 z-[60] h-0.5 w-full bg-brand-blue-link"
        style={{
          marginLeft: `${(-1 + progress) * 100}%`,
          transition: `margin-left ${animationDuration}ms linear`,
        }}
      >
        <div
          className="absolute right-0 block h-full w-25 opacity-100 shadow-xl"
          style={{
            transform: `rotate(3deg) translate(0px, -4px)`,
          }}
        />
      </div>
    </div>
  )
}

export default Loading
